module.exports = __webpack_public_path__ + "img/content7-6.6a8cce4c.webp";